import styled from "styled-components";

export const ButtonElement = styled.button`
  background-color: #008000;
  width: 100%;
  color: white;
  padding: 5px;
  border-radius: 4px;
`;
